import _slicedToArray from "/opt/build/repo/stories/frontend/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useRef, useEffect, useCallback, useState } from 'react';
export var canHover = typeof window !== 'undefined' ? !window.matchMedia('(hover: none)').matches : false;
var emptyArr = [];
export default (function (enterDelay, leaveDelay) {
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isHovering = _useState2[0],
      setHovering = _useState2[1];

  var timeout = useRef(null);
  var element = useRef(null); // here for compatibility reasons with certain libs

  var setElementRef = useCallback(function (el) {
    return element.current = el;
  }, emptyArr);
  var toggle = useCallback(function (value, delay) {
    if (canHover === false) {
      return;
    }

    if (timeout.current !== null) {
      clearTimeout(timeout.current);
      timeout.current = null;
    }

    if (delay) {
      timeout.current = setTimeout(function () {
        return setHovering(value);
      }, delay);
    } else {
      setHovering(value);
    }
  }, emptyArr);
  var onEnter = useCallback(function () {
    return toggle(true, enterDelay);
  }, [enterDelay, toggle]);
  var onLeave = useCallback(function () {
    return toggle(false, leaveDelay);
  }, [leaveDelay, toggle]);
  useEffect(function () {
    if (element.current !== null) {
      element.current.addEventListener('mouseenter', onEnter);
      element.current.addEventListener('mouseleave', onLeave);
    }

    return function () {
      if (element.current !== null) {
        element.current.removeEventListener('mouseenter', onEnter);
        element.current.removeEventListener('mouseleave', onLeave);
      }
    };
  }, [element.current, onEnter, onLeave]); // cleans up timeout on unmount

  useEffect(function () {
    return function () {
      return timeout.current !== null && clearTimeout(timeout.current);
    };
  }, emptyArr);
  return [setElementRef, isHovering];
});